import { Component } from '@angular/core';
import { SimpleResponsiveCarouselComponent } from '../simple-responsive-carousel/simple-responsive-carousel.component';

@Component({
  selector: 'grid-banners',
  templateUrl: './grid-banners.component.html',
  styleUrl: './grid-banners.component.scss',
  standalone: false,
})
export class GridBrandsComponent extends SimpleResponsiveCarouselComponent {}
